<template>
  <div class="investment-form">
    <div class="header">
      Información adicional <div @click="$emit('openStep')"><span class="mdi mdi-chevron-down"></span></div>
    </div>
    <div class="form">
      <div class="description">
        ¿Eres una Persona Expuesta Políticamente (PEP) o tienes una relación cercana, familiar o
        laboral a una PEP? Una persona expuesta políticamente es una persona física que tiene o ha
        tenido una función publica importante en el estado o en el manejo de una organización
        internacional.
      </div>
      <BaseRadio :options="booleanOptions" v-model="data.isPep" />
      <div class="description">
        ¿Eres un inversionista calificado? Como inversionista calificado se define a todas las
        personas que tengan inversiones cuyo valor sea igual o mayor a 1,500,000 UDI´S (Unidades de
        Inversión); o que cuenten con ingresos brutos anuales iguales o mayores a 500,000 unidades
        de inversión en cada uno de los últimos dos años.
      </div>
      <BaseRadio :options="booleanOptions" v-model="data.isQualifiedInvestor" />
    </div>
    <div class="button-wrapper">
      <div class="button" :class="{ disabled: !formFilled }" @click="saveData">
        Siguiente
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BaseRadio from '@/components/base/BaseRadio.vue';

const { mapState, mapActions } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      data: {},
      booleanOptions: [
        { text: 'Si', value: true },
        { text: 'No', value: false },
      ],
    };
  },
  components: {
    BaseRadio,
  },
  watch: {
    user() {
      this.data = { ...this.user };
    },
  },
  computed: {
    formFilled() {
      const fields = ['isPep', 'isQualifiedInvestor'];
      for (let i = 0; i < fields.length; i += 1) {
        const key = fields[i];
        if (this.data[key] === null) {
          return false;
        }
      }
      return true;
    },
    ...mapState([
      'user',
    ]),
  },
  methods: {
    async saveData() {
      if (this.formFilled) {
        await this.updateUser(this.data);
        this.$emit('next');
      }
    },
    ...mapActions([
      'updateUser',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.investment-form {
  display: flex;
  flex-wrap: wrap;
}
.description {
  line-height: 1.2rem;
  margin-bottom: 18px;
  margin-top: 20px;

  &:first-of-type {
    margin-top: 0;
  }
}
.header {
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}
/deep/ .form-input {
  font-size: 15px;
  border: none;
  border: 1px solid #d6d6d8;
  padding: 8px;
  font-family: inherit;
  width: 100%;
  border-radius: 4px;

  &:focus {
    border: 1px solid #3479e9;
  }
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
.disabled {
  background-color: lighten($color: #3479e9, $amount: 20);
  cursor: not-allowed;
}
</style>
